import { Reveal, Eyebrow } from "./Reveal";
import { Link } from "react-router-dom";
import { BRIEFINGS } from "@/data/briefings";

export const Insights = () => (
  <section id="insights" data-testid="insights-section" className="py-28 lg:py-36 bg-[#121215] hairline-t hairline-b">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-xl">
          <Eyebrow>Insights & Briefings</Eyebrow>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium tracking-wide text-white leading-snug">
            Desk notes from the <span className="gold-text">physical market.</span>
          </h2>
        </div>
        <a href="/insights" data-testid="insights-subscribe-link" className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] hover:text-[#E8C85A] transition-colors">
          All briefings & subscriptions →
        </a>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 gap-px bg-[#C9A227]/15 card-line">
        {BRIEFINGS.slice(0, 3).map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}>
            <Link to={`/insights/${a.slug}`} data-testid={`insight-card-${a.slug}`} className="block group bg-[#0A0A0B] p-9 h-full hover:bg-[#16161A] transition-colors">
              <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-400">{a.date}</span>
              <h3 className="mt-5 font-display text-lg text-white tracking-wide leading-snug group-hover:text-[#E8C85A] transition-colors">
                {a.title}
              </h3>
              <p className="mt-4 text-sm text-zinc-400 leading-relaxed line-clamp-3">{a.dek}</p>
              <span className="mt-6 inline-block text-[11px] uppercase tracking-[0.22em] text-[#C9A227]">Read briefing →</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
